import { render, staticRenderFns } from "./GlobalSpecsShowMaterialAndLabourList.vue?vue&type=template&id=7b75a8c0&"
import script from "./GlobalSpecsShowMaterialAndLabourList.vue?vue&type=script&lang=js&"
export * from "./GlobalSpecsShowMaterialAndLabourList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports